import Swiper, { Navigation, Pagination, EffectFade, EffectCreative, Autoplay, Mousewheel, Lazy, Thumbs, Grid } from "swiper"

Swiper.use([Navigation, Pagination, EffectFade, EffectCreative, Autoplay, Mousewheel, Lazy, Thumbs, Grid])

document.addEventListener("DOMContentLoaded", () => {
    initSliders()
})

function initSliders() {
    // main-banner
    let mainBanner = document.querySelector('.main-banner')
    
    // ставим на фон блока картинку первого слайда, чтобы при переключении слайдов не было пустоты позади
    // let mainBannerImg = mainBanner.querySelector('.main-banner__slide:first-child .main-banner__bg img').getAttribute('src')
    // mainBanner.style.backgroundImage = " url("+ mainBannerImg +") "

    if (mainBanner) {
        const pagination = document.querySelectorAll(".main-banner__nav-item")
        const mainBannerSlider = new Swiper(".main-banner__slider", {
            spaceBetween: 0,
            slidesPerView: 1,
            speed: 500,
            autoplay: {
                delay: 7000,
                disableOnInteraction: false,
            },
            loop: true,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            on: {
                slideChangeTransitionStart() {
                    pagination.forEach((page, index) => {
                        page.classList.remove("active")
                        if (index === this.realIndex) {
                            page.classList.add("active")
                        }
                    })
                },
            },
        })
        pagination.forEach((page, index) => {
            page.addEventListener("mouseover", () => {
                mainBannerSlider.slideToLoop(index)
            })
        })

        if (window.matchMedia("(min-width: 769px)").matches) {
            mainBannerSlider.autoplay.stop()
            setTimeout(() => {
                mainBanner.classList.add('js__active')
                mainBannerSlider.autoplay.start()
            }, 3500)
        } else {
            mainBanner.classList.add('js__active')
            mainBannerSlider.autoplay.stop()
        }

    }

    // banner-slider
    let bannerSlider = document.querySelectorAll(".banner-slider")
    if (bannerSlider.length) {
        bannerSlider.forEach((slider) => {
            if(slider.querySelectorAll('.banner-slider__item').length <= 1) {
                slider.querySelector('.swiper-button-prev').style.display = 'none'
                slider.querySelector('.swiper-button-next').style.display = 'none'
            }
            let bannerSliderSwiper = new Swiper(slider, {
                spaceBetween: 8,
                slidesPerView: 'auto',
                // lazy: true,
                // lazy: {
                //     loadPrevNext: true,
                // },
                autoplay: {
                    delay: 7000,
                },
                navigation: {
                    prevEl: slider.querySelector(".swiper-button-prev"),
                    nextEl: slider.querySelector(".swiper-button-next"),
                },
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                    clickable: true,
                }
            })
        })
    }

    // gallery-slider
    let gallerySlider = document.querySelectorAll(".gallery-slider")
    if (gallerySlider.length) {
        gallerySlider.forEach((slider) => {
            if(slider.querySelectorAll('.gallery-slider__item').length <= 1) {
                slider.querySelector('.swiper-button-prev').style.display = 'none'
                slider.querySelector('.swiper-button-next').style.display = 'none'
            }
            let gallerySliderSwiper = new Swiper(slider, {
                spaceBetween: 8,
                slidesPerView: 'auto',
                // lazy: true,
                // lazy: {
                //     loadPrevNext: true,
                // },
                autoplay: {
                    delay: 7000,
                },
                navigation: {
                    prevEl: slider.querySelector(".swiper-button-prev"),
                    nextEl: slider.querySelector(".swiper-button-next"),
                },
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                    clickable: true,
                }
            })
        })
    }

    // product-slider
    let productSlider = document.querySelectorAll(".product-slider__list")
    if (productSlider.length) {
        productSlider.forEach((slider) => {
            let productSliderSwiper = new Swiper(slider, {
                spaceBetween: 8,
                slidesPerView: '2',
                // autoplay: {
                //     delay: 7000,
                // },
                navigation: {
                    prevEl: slider.querySelector(".swiper-button-prev"),
                    nextEl: slider.querySelector(".swiper-button-next"),
                },
                pagination: {
                    el: slider.querySelector('.swiper-pagination'),
                    type: 'bullets',
                    clickable: true,
                },
                breakpoints: {
                    720: {
                        slidesPerView: 4,
                    },
                    520: {
                        slidesPerView: 3,
                    },
                    420: {
                        slidesPerView: 2,
                    }
                },
            })
        })
    }

    // cart-block__slider
    let cartBlockSlider = document.querySelectorAll(".cart-block__slider-list")
    if (cartBlockSlider.length) {
        cartBlockSlider.forEach((slider) => {
            let cartBlockSliderSwiper = new Swiper(slider, {
                spaceBetween: 8,
                slidesPerView: 2,
                navigation: {
                    prevEl: slider.querySelector(".swiper-button-prev"),
                    nextEl: slider.querySelector(".swiper-button-next"),
                },
                breakpoints: {
                    1000: {
                        slidesPerView: 1,
                    },
                    768: {
                        slidesPerView: 2,
                    },
                },
            })
        })
    }

    // product-card__slider
    let productCardImg = document.querySelectorAll(".product-card__img")
    if (productCardImg.length) {
        productCardImg.forEach((slider) => {
            let productCardImgThumbs = new Swiper(slider.querySelector('.product-card__thumbs'), {
                spaceBetween: 8,
                slidesPerView: 'auto',
                autoplay: {
                    delay: 5000,
                },
                watchSlidesProgress: true,
            })
            let productCardImgSlider = new Swiper(slider.querySelector('.product-card__slider'), {
                spaceBetween: 8,
                slidesPerView: '1',
                autoplay: {
                    delay: 5000,
                },
                navigation: {
                    prevEl: slider.querySelector(".swiper-button-prev"),
                    nextEl: slider.querySelector(".swiper-button-next"),
                },
                thumbs: {
                    swiper: productCardImgThumbs
                },
            })
        })
    }

    // order-date
    let orderDateSlider = document.querySelectorAll(".order-date__slider")
    if (orderDateSlider.length) {
        orderDateSlider.forEach((slider) => {
            let orderDateSliderSwiper = new Swiper(slider, {
                spaceBetween: 8,
                slidesPerView: 'auto',
                navigation: {
                    prevEl: slider.querySelector(".swiper-button-prev"),
                    nextEl: slider.querySelector(".swiper-button-next"),
                },
            })
        })
    }

    // designers-slider
    let designersSlider = document.querySelectorAll(".designers-slider")
    if (designersSlider.length) {
        designersSlider.forEach((slider) => {
            let designersSliderSwiper = new Swiper(slider, {
                spaceBetween: 8,
                slidesPerView: 1,
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                    clickable: true,
                },
                breakpoints: {
                    720: {
                        slidesPerView: 3,
                    },
                    420: {
                        slidesPerView: 2,
                    }
                },
            })
        })
    }

    // certificates-slider
    let certificatesSlider = document.querySelectorAll(".certificates-slider")
    if (certificatesSlider.length) {
        certificatesSlider.forEach((slider) => {
            let certificatesSliderSwiper = new Swiper(slider, {
                spaceBetween: 8,
                slidesPerView: 1,
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                    clickable: true,
                },
                breakpoints: {
                    720: {
                        slidesPerView: 3,
                    },
                    420: {
                        slidesPerView: 2,
                    }
                },
            })
        })
    }

    // awards-slider
    let awardsSlider = document.querySelectorAll(".design-block:not(.omay-design) .awards-slider")
    if (awardsSlider.length) {
        awardsSlider.forEach((slider) => {
            let awardsSliderSwiper = new Swiper(slider, {
                slidesPerView: 2,
                spaceBetween: 8,
                grid: {
                    rows: 4,
                },
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                    clickable: true,
                },
                breakpoints: {
                    720: {
                        slidesPerView: 3,
                    },
                    420: {
                        slidesPerView: 2,
                    }
                }
            })
        })
    }

    // history-slider
    let historySlider = document.querySelector('.history-slider')
    if (historySlider) {
        const historySliderNav = historySlider.querySelectorAll(".history-slider__nav:not(.swiper-container) .history-slider__nav-item")

        let historySliderNavSwiper = new Swiper(historySlider.querySelector('.history-slider__nav.swiper-container'), {
            spaceBetween: 8,
            slidesPerView: 'auto',
            watchSlidesProgress: true,
        })
        const historySliderSwiper = new Swiper(historySlider.querySelector(".history-slider__list"), {
            spaceBetween: 8,
            slidesPerView: 1,
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true,
                // dynamicBullets: true,
                // dynamicMainBullets: 3,
            },
            effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
            thumbs: {
                swiper: historySliderNavSwiper
            },
            on: {
                slideChangeTransitionStart() {
                    historySliderNav.forEach((page, index) => {
                        page.classList.remove("active")
                        if (index === this.realIndex) {
                            page.classList.add("active")
                        }
                    })
                },
            },
        })

        historySliderNav.forEach((page, index) => {
            page.addEventListener("click", () => {
                historySliderSwiper.slideToLoop(index)
            })
        })
    }

}

